import { render, staticRenderFns } from "./onremark.vue?vue&type=template&id=6604496c"
import script from "./onremark.vue?vue&type=script&lang=js"
export * from "./onremark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports